import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { AttendanceSession } from '../../types/entity.types';
import {
  CreateAccountabilityTemplateRequest,
  GenerateAccountabilityTemplateSessionRequest,
  UpdateAccountabilityTemplateRequest,
  ViewAccountabilityTemplateRequest
} from './accountability-template.types';

import {
  requestCreateAccountabilityTemplate,
  requestGenerateAccountabilityTemplateSessions,
  requestUpdateAccountabilityTemplate,
  requestViewAccountabilityTemplate
} from './accountability-template.actions';

export const useAccountabilityTemplateApi = () => {
  const dispatch = useDispatch();

  const createAccountabilityTemplate = useCallback(
    (requestData: CreateAccountabilityTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestCreateAccountabilityTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewAccountabilityTemplate = useCallback(
    (requestData: ViewAccountabilityTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestViewAccountabilityTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateAccountabilityTemplate = useCallback(
    (requestData: UpdateAccountabilityTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateAccountabilityTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const generateAccountabilityTemplateSessions = useCallback(
    (
      requestData: GenerateAccountabilityTemplateSessionRequest,
      onSuccess?: (sessionTemplates: AttendanceSession[]) => void
    ) => {
      dispatch(requestGenerateAccountabilityTemplateSessions({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return {
    createAccountabilityTemplate,
    viewAccountabilityTemplate,
    updateAccountabilityTemplate,
    generateAccountabilityTemplateSessions
  };
};
